import { safeGet } from '../../../../../../core/util/object';

export const getCityLabelFromGeosuggestValue = geoSuggestValue => {
  if (!safeGet(geoSuggestValue)('address_components')) return null;
  const addressComponent = geoSuggestValue.address_components.filter(component =>
    component.types.includes('locality')
  );
  return safeGet(addressComponent)('0.long_name');
};
